import { Icon, Icons } from '../Icon'
import { Spinner } from '../Spinner'
import { Span } from '../Typography/Span'
import * as S from './elements'
import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC, useRef } from 'react'
import { MarginProps, MaxWidthProps, MinWidthProps, SpaceProps, WidthProps } from 'styled-system'

export interface Props
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    MarginProps,
    SpaceProps,
    WidthProps,
    MinWidthProps,
    MaxWidthProps {
  variant?: 'primary' | 'secondary' | 'tertiary'
  isLoading?: boolean
  isLoadingText?: string
  icon?: keyof Icons
  iconPosition?: 'left' | 'right'
}

type ButtonType = ButtonHTMLAttributes<HTMLButtonElement> & {
  as?: 'button'
}
type LinkType = AnchorHTMLAttributes<HTMLAnchorElement> & {
  as?: 'link'
  disabled?: boolean
}

type ButtonAs = ButtonType | LinkType

export const Button: FC<ButtonAs & Props> = React.forwardRef((props, ref) => {
  const {
    variant = 'primary',
    isLoading,
    isLoadingText,
    children,
    icon,
    iconPosition = 'right',
    as = 'button',
    disabled,
    width = 'auto',
    ...rest
  } = props
  const buttonRef = useRef<HTMLButtonElement | undefined>(undefined)

  const Comp: any = as === 'button' ? S.Button : S.Link
  return (
    <Comp
      {...rest}
      width={width}
      variant={variant}
      ref={ref}
      icon={icon}
      iconPosition={iconPosition}
      minWidth={buttonRef && buttonRef.current ? buttonRef.current.clientWidth : undefined}
      isLoading={isLoading}
      disabled={isLoading || disabled}
    >
      <S.Content display={isLoading ? 'none' : 'flex'}>
        {icon && iconPosition === 'left' && <Icon icon={icon} size={40} />}
        {children}
        {icon && iconPosition === 'right' && <Icon icon={icon} size={40} />}
      </S.Content>
      {isLoadingText && isLoading && <Span>{isLoadingText}</Span>}
      {isLoading && !isLoadingText && (
        <>
          <Spinner size={40} />
        </>
      )}
    </Comp>
  )
})
